module.exports = __webpack_public_path__ + "img/wxchat.e199a8ec.png";